import type { Root as HastRoot } from 'hast';
import { createContext } from 'react';

export const HastRendererContext = createContext<HastRoot>(null);
